import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { ExportImportService } from "src/app/services/export-import.service";

@Component({
  selector: "app-secure-export-pol",
  templateUrl: "./export-pol.component.html",
  styleUrls: ["./export-pol.component.scss"],
})
export class ExportPolComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isLoading = false;
  lotteryList: {[key: number]: string};
  isSubmitDisabled: boolean = false;
  lotteryKey: number;
  downloadedBatches: string[] = [];
  applicationNo: string;
  
  constructor(
    private router: Router,
    private exportImportService: ExportImportService
    , private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {

    this.form = new FormGroup({
      applicationNo: new FormControl(null, Validators.required),
    });

    this.isLoading = true;
    

  }

 
  refresh() {
    this.loadData();
  }

  

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  onSubmit() {

    if(this.form.value.applicationNo !==null ){
      console.log(this.form.value.applicationNo);
      this.exportImportService.downloadPol(this.form.value.applicationNo)
      .subscribe((data) => {
        this.isLoading = false;
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadedBatches.push(this.form.value.applicationNo);
          this.downloadFile(data.base64File, data.fileName);
          this.successToast();
        }
        else {
          this.exportImportService.errorToast(data.errorMessage);  
        }
      }, error => {
        this.isLoading = false;
        this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
        // this.exportImportService.errorToast("Please Enter Application Number:"+this.form.value.applicationNo);

      });
  
    } else {
      this.exportImportService.errorToast("Please Enter Application Number");  
    }

    
  }
  async successToast() {
    await this._snackBar.open(
        " POL Successfully Downloaded",
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}
}